import Describer from "../../../utils/issues/issue_description/describer";

function render(issue, topics) {
  const describer = new Describer.IssueDescriber(issue, topics);
  return `${describer.listChildIssues} on the same whole clause`;
}

export default render;
